"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.appointmentBookingsOffered = exports.openSaturdays = exports.openWeekdaysAfter5pm = exports.openTomorrow = exports.openToday = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const weekdays = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
];
const openToday = (availability) => {
    if (availability === undefined) {
        return false;
    }
    const tz = availability.timezone;
    const today = (0, moment_timezone_1.default)().tz(tz);
    const opensAt = moment_timezone_1.default.tz(availability.opens_time, tz);
    const closesAt = moment_timezone_1.default.tz(availability.closes_time, tz);
    return today.isSame(opensAt, "day") || today.isSame(closesAt, "day");
};
exports.openToday = openToday;
const openTomorrow = (availability) => {
    if (availability === undefined) {
        return false;
    }
    const tz = availability.timezone;
    const today = (0, moment_timezone_1.default)().tz(tz).add(1, "day");
    const opensAt = moment_timezone_1.default.tz(availability.opens_time, tz);
    const closesAt = moment_timezone_1.default.tz(availability.closes_time, tz);
    return today.isSame(opensAt, "day") || today.isSame(closesAt, "day");
};
exports.openTomorrow = openTomorrow;
const openWeekdaysAfter5pm = (availability) => weekdays.some((weekday) => {
    var _a;
    return (_a = availability === null || availability === void 0 ? void 0 : availability.hours[weekday].some((schedule) => {
        const closeTimeMinutes = schedule.hour * 60 + schedule.minute + schedule.event_duration_minutes;
        return closeTimeMinutes > 17 * 60; // open after 5 p.m.
    })) !== null && _a !== void 0 ? _a : false;
});
exports.openWeekdaysAfter5pm = openWeekdaysAfter5pm;
const openSaturdays = (availability) => { var _a; return ((_a = availability === null || availability === void 0 ? void 0 : availability.hours.saturday.length) !== null && _a !== void 0 ? _a : 0) > 0; };
exports.openSaturdays = openSaturdays;
const appointmentBookingsOffered = (availability) => { var _a, _b; return (_b = (_a = availability === null || availability === void 0 ? void 0 : availability.hours_notes_en) === null || _a === void 0 ? void 0 : _a.includes("s2i:OTQ000001")) !== null && _b !== void 0 ? _b : false; };
exports.appointmentBookingsOffered = appointmentBookingsOffered;
